import bottleFactory from './bottle';

const bottle = bottleFactory();

const {
  customVocabularyAddRecord,
  customVocabularyUpdateRecord,
  customVocabularyRemoveRecords,
  customVocabularyFetchRecord,
  customVocabularyFetchAll,
  customVocabularyModel,
  recordToID,
} = bottle.container;

export default customVocabularyModel;

export {
  customVocabularyAddRecord,
  customVocabularyUpdateRecord,
  customVocabularyRemoveRecords,
  customVocabularyFetchRecord,
  customVocabularyFetchAll,
  recordToID,
};
